<template>
  <!--高级搜搜-->
  <el-drawer
    :append-to-body="true"
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    custom-class="drawerClass"
    direction="ltr"
    size="600px"
  >
    <div class="app-container">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <!-- 投诉类型 -->
            <el-form-item :label="$t('tablePrice.workOrderType')">
              <el-select
                v-model="searchParams.workOrderType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
                @change="changeWorkOrderType(searchParams.workOrderType, '1')"
              >
                <el-option
                  v-for="(item, index) in complaintTypeList()"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 投诉来源 -->
            <el-form-item :label="$t('tablePrice.complaintType')">
              <el-select
                v-model="searchParams.complaintType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in complaintSourceList()"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  处理状态   -->
            <el-form-item :label="$t('GlobalSetObj.ProcessingStatus')">
              <el-select
                v-model="searchParams.processingStateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                multiple
                style="width: 100%"
              >
                <el-option key="2" :label="$t('GlobalSetObj.Pending')" :value="0" /><!--待处理-->
                <el-option key="3" :label="$t('newOrder.processing')" :value="1" /><!--处理中-->
                <el-option
                  key="4"
                  :label="$t('collectionCenter.closedLoop')"
                  :value="2"
                /><!--已闭环-->
                <el-option key="5" :label="$t('collectionCenter.cancelled')" :value="3" /><!--已取消-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  处理结果   -->
            <el-form-item :label="$t('collectionCenter.processingResult')">
              <el-select
                v-model="searchParams.processingResult"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in processingResultList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 是否超时 -->
            <el-form-item :label="$t('orderCenterCont.TimeoutOrNot')">
              <el-select
                v-model="searchParams.istimeOut"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('GlobalSetObj.yes')" :value="1" /><!--是-->
                <el-option :key="0" :label="$t('GlobalSetObj.No')" :value="0" /><!--否-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  客户  -->
            <el-form-item :label="$t('GlobalSetObj.client')">
              <el-select
                v-model="searchParams.customerId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getCustomerPage"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @clear="getCustomerPage"
              >
                <el-option
                  v-for="(item, index) in customerList"
                  :key="index"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--商户-->
            <el-form-item :label="$t('placeOrder.CommercialOwner')">
              <el-select
                v-model="searchParams.merchantName"
                :placeholder="$t('placeOrder.pleaseChoose')"
                :remote-method="getShanghu"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @clear="getShanghu"
              >
                <el-option
                  v-for="item in commercialList"
                  :key="item.id"
                  :label="item.merchantName"
                  :value="item.merchantName"
                >
                  <div>
                    <span>{{ item.merchantName }}</span>
                    <span style="margin-left: 30px">{{ item.merchantCode }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="searchParams.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="changeRegion"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 网点所属州 -->
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="searchParams.state"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
                @change="changeState"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.nameEn"
                  :value="item.twoCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 实际派送网点 -->
            <el-form-item :label="$t('GlobalSetObj.entrega')">
              <el-select
                v-model="searchParams.siteName"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 登记人 -->
            <el-form-item :label="$t('collectionCenter.registrar')">
              <el-select
                v-model="searchParams.registerUserId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getRegisterUserList"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @clear="getRegisterUserList()"
              >
                <el-option
                  v-for="item in registerUserList"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <!--搜索-->
            <el-button
              size="small" type="primary" @click="clickSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              size="small" type="info" @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { complaintSourceList, complaintTypeList, processingResultList } from '@/utils/enumData';
import { apiCustomerPage } from '@/api/customer';
import { apiGetComplaintGetMerchantName } from '@/api/newExpressAPI';
import { getLgAreaListData, regionQueryList, selectInfoByStateTwo } from '@/api/orderApi';
import { getUserPage } from '@/api/user';
import { Loading } from 'element-ui';
import $i18n from '@/lang';

export default {
  name: 'SearchCom',
  data() {
    return {
      allSiteListCache: null, // 全部网点数据缓存
      sitesByRegionAndState: {},
      regionList: [],
      processingResultList: [],
      customerList: [],
      commercialList: [],
      stateList: [],
      siteList: [], // 网点
      registerUserList: [],
      searchDrawer: false,
      searchParams: {
        workOrderType: null,
        customerName: [],
        registerUserName: [],
        processingStateList: [], // 状态: 1-待处理 2-处理中 3-已闭环
        processingResult: [], // 处理结果: 0.虚假签收，1.无责 2.全部丢失 3.部分丢失
        customerId: [], // 客户名称
        merchantName: [], // 商户名称
        istimeOut: null, // 是否超时: 1-是, 2-否
        complaintType: null,
        state: [], // 网点所属州
        siteName: [], // 网点名称
        registerUserId: [], // 登记人id
        regionId: null
      }
    };
  },
  mounted() {
    this.getRegion();
    this.getAddress();
    this.getAllSiteList();
  },
  methods: {
    changeWorkOrderType(val, type) {
      console.log(val, 'changeWorkOrderType');
      if (type === '1') {
        this.searchParams.processingResult = [];
      }
      if (val === 1 || val === 4) {
        this.processingResultList = [
          { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
          { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
          { label: $i18n.t('compensationManagement.PartiallyLost'), value: 3 },
          { label: $i18n.t('home.goodsNOfuhe'), value: 5 },
          { label: $i18n.t('home.infoError'), value: 6 },
          { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
          { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
          { label: $i18n.t('tablePrice.confirmedLost'), value: 10 }
        ];
      } else if (val === 0) {
        this.processingResultList = [
          { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
          { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
          { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
          { label: $i18n.t('tablePrice.confirmedLost'), value: 10 },
          { label: $i18n.t('compensationManagement.trackingUpdated'), value: 11 }
        ];
      } else if ([2, 3].includes(val)) {
        this.processingResultList = [
          { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
          { label: $i18n.t('compensationManagement.established'), value: 12 },
          { label: $i18n.t('compensationManagement.notEstablished'), value: 13 }
        ];
      } else {
        this.processingResultList = processingResultList;
      }
    },
    complaintSourceList() {
      return complaintSourceList;
    },
    complaintTypeList() {
      return complaintTypeList;
    },
    // 加change函数监控州、网点
    changeRegion(val) {
      this.searchParams.state = [];
      this.searchParams.siteName = [];
      this.stateList = [];
      this.siteList = [];
      if (!val) {
        this.searchParams.state = [];
        this.searchParams.siteName = [];
        this.getAddress();
        this.getAllSiteList();
        return;
      }
      if (val && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === val);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateList = selectedRegion.states.map((label) => ({
            nameEn: label,
            twoCode: label
          }));
        }
        this.siteList = selectedRegion?.sites || [];
      }
    },
    changeState(val) {
      if (this.searchParams.regionId) {
        this.searchParams.siteName = [];
      }
      if (!this.searchParams.regionId && val) {
        if (this.allSiteListCache) {
          this.siteList = this.allSiteListCache;
        } else {
          this.getAllSiteList(); // 如果缓存不存在再请求
        }
        return;
      }
      if ((!val || val.length <= 0) && this.searchParams.regionId) {
        const selectedRegion = this.regionList.find((r) => r.id === this.searchParams.regionId);
        this.siteList = selectedRegion?.sites || [];
      }
      if (this.searchParams.regionId && val && val.length > 0) {
        const selectedRegion = this.regionList.find(
          (item) => item.id === this.searchParams.regionId
        );
        if (selectedRegion && Array.isArray(selectedRegion.sites)) {
          this.siteList = selectedRegion.sites.filter((site) => val.includes(site.state));
        }
      }
    },
    // 大区
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    clickSearch() {
      console.log(this.searchParams, 'clickSearch');
      if (this.searchParams && Object.keys(this.searchParams).length) {
        if (this.searchParams.customerId && this.searchParams.customerId.length) {
          this.searchParams.customerName = this.customerList
            .filter((item) => this.searchParams.customerId.includes(item.id))
            .map((item) => item.customerAlias);
        }
        if (this.searchParams.registerUserId && this.searchParams.registerUserId.length) {
          this.searchParams.registerUserName = this.registerUserList
            .filter((item) => this.searchParams.registerUserId.includes(item.id))
            .map((item) => item.username);
        }
      }
      this.$emit('child-event01', this.searchParams);
      this.searchDrawer = false;
    },
    resetForm() {
      Object.assign(this.searchParams, {
        workOrderType: null,
        customerName: [],
        registerUserName: [],
        processingStateList: [], // 状态: 1-待处理 2-处理中 3-已闭环
        processingResult: [], // 处理结果: 0.虚假签收，1.无责 2.全部丢失 3.部分丢失
        customerId: [], // 客户名称
        merchantName: [], // 商户名称
        istimeOut: null, // 是否超时: 1-是, 2-否
        complaintType: null,
        state: [], // 网点所属州
        siteName: [], // 网点名称
        registerUserId: [], // 登记人id
        regionId: null
      });
      this.getAddress();
      this.getAllSiteList();
      this.getCustomerPage();
      this.getShanghu();
      this.getRegisterUserList();
      this.changeWorkOrderType('');
      this.$emit('child-event01', this.searchParams);
    },
    showDialog(isResult, params) {
      if (isResult !== true) {
        this.getCustomerPage();
        this.getShanghu();
        this.getRegisterUserList();
        this.changeWorkOrderType('', 2);
      }
      console.log(params, 'paramsparams');
      this.searchParams = params;
      if (this.searchParams && Object.keys(this.searchParams).length) {
        this.changeWorkOrderType(this.searchParams.workOrderType, '2');
      }
      this.searchDrawer = true;
    },
    closeDrawer() {
      this.searchDrawer = false;
    },
    // 获取客户
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 获取商户
    getShanghu(name = '') {
      const data = {
        // orderType: 0,
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantNames: name,
          customerName: [] // this.queryForm.params.customerId
        }
      };
      apiGetComplaintGetMerchantName(data, false).then((res) => {
        if (res.code === 200) {
          this.commercialList = res.data.records;
        }
      });
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data;
        }
      });
    },
    // 获取所有网点
    getAllSiteList() {
      if (this.allSiteListCache) {
        this.siteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      selectInfoByStateTwo({})
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.siteList = [...this.allSiteListCache]; // 初始化为全量数据
          }
        })
        .finally(() => {
          load.close();
        });
    },
    // 获取登记人选项
    getRegisterUserList(name = '') {
      const data = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          accountState: '1',
          username: name
        }
      };
      getUserPage(data).then((res) => {
        if (res.code === 200) {
          this.registerUserList = res.data.records;
        }
      });
    }
  }
};
</script>

<style scoped></style>
